// Typed wrapper around the auto-generated design tokens that flow in from
// the figma-export plugin's Tokens tab → manifest → token transformer.
//
// We import the **JSON** mirror (`design-tokens/tokens.json`) rather than
// the CJS sibling (`design-tokens/tokens.cjs`) because CRA's webpack + babel
// pipeline interops the `.cjs` extension inconsistently — default-import
// landed as `undefined`, named imports were rejected ("default-exporting
// module only"), and a raw `require()` returned a non-object that broke
// the `in` operator at module-evaluation time. JSON imports are first-class
// in CRA (`resolveJsonModule: true`), so this path is bulletproof.
//
// `tokens.json` is generated alongside `tokens.cjs` by the token transformer
// — see `tools/token_transformer/src/generator.ts`. Keep both in sync if you
// touch the generator output.
import tokens from '../../../../design-tokens/tokens.json'

export type FontSizeValue =
    | string
    | [string, { lineHeight?: string; letterSpacing?: string; fontWeight?: string }]

export interface DesignTokens {
    colors: Record<string, Record<string, string>>
    spacing: Record<string, string>
    borderRadius: Record<string, string>
    maxWidth: Record<string, string>
    fontSize: Record<string, FontSizeValue>
    fontFamily: Record<string, string[]>
    fontWeight: Record<string, string>
    letterSpacing: Record<string, string>
    lineHeight: Record<string, string>
}

// `import` on JSON widens tuple-shaped values like `['14px', { lineHeight }]`
// to plain arrays, so we cast through `unknown` to land on the tuple-typed
// `DesignTokens` interface.
export const designTokens = tokens as unknown as DesignTokens
